import { useMemo } from 'react';
import { Params } from 'react-router-dom';
import useQueryParams from './useQueryParams';

export const paramsWith$ = [
  'sort',
  'page',
  'limit',
  'searchString',
  'projection',
  'relations',
  'or',
];

export default function useSearchParams(defaultParams?: Record<string, any>) {
  const { params } = useQueryParams<Params>();

  return useMemo(
    () =>
      Object.entries({
        ...defaultParams,
        ...params,
      }).reduce<Record<string, any>>((acc, [key, value]) => {
        acc[`${paramsWith$.includes(key) ? '$' : ''}${key}`] = value;
        return acc;
      }, {}),
    [defaultParams, params],
  );
}
